import { Autocomplete, AutocompleteProps, AutocompleteRenderInputParams, MenuItem, TextField, TextFieldProps } from "@mui/material";
import { useField, useFormikContext } from "formik";
import i18next from "i18next";
import React, { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

//! -------------------------------------------------------------------------------------------------- //

export interface SelectTypes {
    name: string;
    options: CountriesType[];
    // type: string;
    [otherProps: string]: any;
}

// interface CountriesType {
//   num_code: string;
//   alpha_2_code: string;
//   alpha_3_code: string;
//   en_short_name: string;
//   nationality: string;
// }
interface CountriesType {
    id: number;
    name: { en: string; nl: string; fr: string };
    nationality?: { en: string; nl: string; fr: string };
}

// export enum CountriesTypeSelection {
//   COUNTRY = "country",
//   NATIONALITY = "nationality",
// }

const SelectWrapper = ({ name, options, ...otherProps }: SelectTypes) => {
    const locale = i18next.language === undefined ? "nl" : i18next.language;
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);
    const { t } = useTranslation();

    const sorted =
        locale === "en"
            ? options.sort((a, b) => a.name.en.localeCompare(b.name.en))
            : locale === 'fr' ? options.sort((a, b) => a.name.fr.localeCompare(b.name.fr)) 
            : options.sort((a, b) => a.name.nl.localeCompare(b.name.nl));

    const handleChange = (event: any, value: string | null) => {
        event.stopPropagation();
        setFieldValue(name, value);
    };

    const selectProps: TextFieldProps = {
        ...field,
        ...otherProps
    }

    const autocomploteProps: any = {
        ...field,
        ...otherProps,
        options: Object.keys(sorted).map((index, value) => {
            if (locale === 'en')
                return options[parseInt(index)].name.en;
            else if (locale === 'fr')
                return options[parseInt(index)].name.fr;
            else
                return options[parseInt(index)].name.nl;
        }),
        renderInput: (params: any) => <TextField {...params} {...selectProps} />,
        onChange: handleChange,
        fullWidth: true,
    }

    if (meta && meta.touched && meta.error) {
        selectProps.error = true;
        selectProps.helperText = t(meta.error);
    }

    return (
        <Autocomplete {...autocomploteProps} />
    );
};

export default SelectWrapper;
